module.exports = __webpack_public_path__ + "static/img/r-7.d446090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-7.jpg
// module id = KTbw
// module chunks = 0